import { matchPath } from 'react-router';

import { RouteEnum } from 'app/shared/enums';

const CALCULATION_FORM_ROUTES: string[] = [
  '/',
  RouteEnum.HOME,
  RouteEnum.CALCULATION,
  RouteEnum.CALCULATION_FORM,
  RouteEnum.MOTORCYCLES,
  `${RouteEnum.MOTORCYCLES}/form`,
  RouteEnum.ACTIVE_PROMOTION,
  `${RouteEnum.ACTIVE_PROMOTION}/form`,
  RouteEnum.PARTNER_LINK,
  `${RouteEnum.PARTNER_LINK}/form`,
];

export const isCalculationFormPath = (pathname: string) =>
  CALCULATION_FORM_ROUTES.some(
    (path) => !!matchPath(pathname, { path, exact: true })
  );
